import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

/**
@function CustomTextField
@description - building UI of TextField
@param {object} props - App props accept all that support in TextField
@param {object} errorMessege - pass validation message for error and helperText
@returns {JSX} CustomTextField UI
@example <CustomTextField variant="outlined" />
 */

/** */
const CustomTextField = ({ errorMessege, ...props }) => {
  return (
    <>
      <TextField
        id="Custom-TextField"
        {...props}
        variant={props.variant ? props.variant : 'outlined'}
        value={props.value ?? ''}
        helperText={errorMessege}
        error={Boolean(errorMessege)}
      />
    </>
  );
};

CustomTextField.propTypes = {
  errorMessege: PropTypes.string.isRequired,
  props: PropTypes.oneOfType([PropTypes.object]).isRequired,
  variant: PropTypes.string,
  value: PropTypes.string,
};

CustomTextField.defaultProps = {
  variant: 'outlined',
  value: '',
};

export default React.memo(CustomTextField);
